module.exports = __webpack_public_path__ + "img/slide2.2543a91e.jpg";